import { Card } from '@radix-ui/themes'
import { useEffect, useState } from 'react'
import React from 'react'

export interface RadioInputOption {
  label: string
  hostname?: string
  tips?: string[]
  ipAddress: string
  type?: string
  placeholder?: string
  required?: boolean
  inputName?: string
}

export interface RadioInputConfiguration {
  textInputValue: string
  selectedRadio: string
}

interface IRadioInputProps {
  config: RadioInputConfiguration
  options: RadioInputOption[]
  defaultOptions: RadioInputOption[]
  readOnly?: boolean
}
function RadioInput({ config, options, defaultOptions, readOnly }: IRadioInputProps) {
  const [selectedRadio, setSelectedRadio] = useState<string | undefined>(undefined)
  const [ipDnsValue, setDnsIp] = useState<string>('')
  const [hostname, setHostname] = useState<string>('')

  useEffect(() => {
    setSelectedRadio(config.selectedRadio)
    const host = config.textInputValue.replace(/^https:\/\//, '').replace(/\/dns-query$/, '')
    setDnsIp(defaultOptions.find((option) => option.hostname === host)?.ipAddress || 'Custom')
    setHostname(host)
  }, [config])

  useEffect(() => {
    setDnsIp(defaultOptions.find((option) => option.hostname === hostname)?.ipAddress || 'Custom')
  }, [hostname])

  return (
    <div className="flex flex-col gap-4">
      {options?.map((radio, i) => (
        <React.Fragment key={radio.ipAddress}>
          <label className="flex gap-2 justify-start">
            <input
              type="radio"
              name="sharedRadio"
              disabled={readOnly}
              value={radio.ipAddress}
              checked={selectedRadio == radio.ipAddress}
              onChange={() => setSelectedRadio(radio.ipAddress)}
              className="focus:ring-mainPurple dark:border-gray-200 dark:bg-black h-8 w-8 mt-1 scale-50 cursor-pointer checked:bg-mainPurple checked:bg-mainPurple"
            />
            <div className="text-mainText dark:text-white text-sm flex flex-col md:flex-row gap-4 w-full">
              <div className="flex flex-col gap-3 w-full pr-4">
                <div className="flex flex-col">
                  <span className="font-semibold">{radio.label}</span>
                  {radio.hostname && <span className="">{radio.hostname}</span>}
                  {radio.tips?.map((tip, index) => (
                    <span key={index} className="text-xs text-gray-500 dark:text-gray-400 mt-1 italic">
                      {tip}
                    </span>
                  ))}
                </div>
                {radio.type == 'text_input' && (
                  <Card className="bg-neutral-100 dark:bg-neutral-800" variant="surface">
                    <div className="flex gap-3 justify-between">
                      <select
                        name={radio.inputName}
                        value={hostname}
                        disabled={selectedRadio !== radio.ipAddress}
                        className={`md:max-w-[150px] w-full min-w-40 not-form-styled border opacity-100
                     ${
                       selectedRadio !== radio.ipAddress
                         ? 'border-mainBorder dark:border-neutral-11 cursor-not-allowed bg-gray-100 text-neutral-500 dark:text-neutral-300'
                         : 'border-neutral-300 dark:border-neutral-9 focus:border-borderPurple hover:border hover:border-borderPurple hover:dark:border-borderPurple bg-inputBackground'
                     }
                    flex dark:bg-inputBackground border-1 rounded px-2 justify-between text-sm`}
                        onChange={(e) => {
                          setHostname(e.target.value)
                        }}
                      >
                        {defaultOptions.map((option) => (
                          <option key={option.ipAddress} value={option.hostname}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                      <div className="flex flex-col md:flex-row gap-1 items-center">
                        <label className="text-neutral-11 dark:text-neutral-8 font-semibold">DNS: </label>
                        <label className="text-mainText dark:text-white text-sm">{ipDnsValue}</label>
                      </div>
                      <div className="flex flex-col md:flex-row gap-1 items-center flex-1">
                        <label className="text-neutral-11 dark:text-neutral-8 font-semibold">Hostname: </label>
                        <label className="text-mainText dark:text-white text-sm">{hostname}</label>
                      </div>
                    </div>
                  </Card>
                )}
              </div>
            </div>
          </label>
          {i !== (options?.length ?? 0) - 1 && <hr className="border-1 border-neutral-4 dark:border-neutral-9" />}
        </React.Fragment>
      ))}
    </div>
  )
}

export default RadioInput
